import type { JSX } from 'react';

import styles from './OperationHistoryDateDivider.module.css';

interface OperationHistoryDateDividerProps {
  label: string;
}

export function OperationHistoryDateDivider({
  label,
}: OperationHistoryDateDividerProps): JSX.Element {
  return <div className={styles.divider}>{label}</div>;
}
